import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bookEvent, fetchEventSlots, fetchUser, resetBooking } from '../../redux/actions';
import moment from 'moment';
import utils from '../../utils';
import PageHeader from '../../components/PageHeader';
import QuickHelp from '../../components/QuickHelp';
import BranchSelector from '../../components/BranchSelector';
import DatePicker from '../../components/DatePicker';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';

import Auth from '../../components/AuthForm';

const initialBooking = {
  people: 30,
  refreshments: true,
  startDate: new Date(),
  room: '',
  slots: []
};

function BookEvent() {
  const dispatch = useDispatch();

  const { branch, eventSlots, slotLoading, bookingLoading, bookingStatus, bookingMessage } = useSelector(({ settings }) => settings);
  const { token, user } = useSelector(({ auth }) => auth);
  const [booking, setBooking] = useState(initialBooking);

  const bookNow = () => {
    const data = {
      ...booking,
      branch: branch._id,
      hours: booking.slots.length * 0.5,
      startDate: moment(booking.startDate).format('YYYY-MM-DD'),
      total: (getRate(booking.room, user.role) * booking.slots.length * 0.5).toFixed(0)
    };
    dispatch(bookEvent(data, token));
  };

  useEffect(() => {
    if (token) {
      dispatch(fetchUser());
    }
  }, [token, dispatch]);

  const getRate = (id, role) => {
    const room = branch.rooms.find(x => x._id === id);
    return role === 'Guest' ? room.guestRate : room.memberRate;
  };

  return (
    <React.Fragment>
      <PageHeader title='Book Event Hall' links={[{ title: 'Home' }, { title: 'Book Event Hall' }]} />
      <section className="write-massage-area pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="write-massage-content">
                <div className="write-massage-title">
                  <h3 className="title">Book Event Hall</h3>
                </div>

                <div className="container">
                  {!token ?
                    <Auth /> :
                    <>
                      {bookingLoading && <CircularProgress />}
                      {bookingMessage ?
                        <div className="row">
                          {bookingMessage &&
                            <div className="col-lg-12 my-5">
                              <small className={bookingStatus === 200 ? "text-success font-weight-bold" : "text-danger font-weight-bold"}>{bookingMessage}</small>
                            </div>
                          }
                          <div className="col-lg-12">
                            <Button variant='outlined' color='primary' onClick={() => {
                              setBooking(initialBooking);
                              dispatch(resetBooking());
                            }}>Continue</Button>
                          </div>
                        </div>
                        :
                        <div className="row">

                          <div className="col-lg-12 my-2">
                            <BranchSelector variant='outlined' size="small" />
                          </div>

                          {branch && branch.rooms &&
                            <div className="col-lg-12 my-2">
                              <FormControl component="fieldset">
                                <FormLabel component="legend">Room</FormLabel>
                                <RadioGroup aria-label="room" name="room" value={booking.room} onChange={(e) => {
                                  setBooking({ ...booking, room: e.target.value, startDate: moment() });
                                  dispatch(fetchEventSlots(branch._id, e.target.value, { start: moment().format('YYYY-MM-DD') }, token));
                                }}>
                                  {branch.rooms.length > 0 && branch.rooms.filter(x => x.category.eventRoom).map((room) => (
                                    <FormControlLabel key={room._id} value={room._id} control={<Radio />} label={room.title} />
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          }

                          {branch && booking.room &&
                            <div className="col-lg-12 my-2">
                              <DatePicker
                                value={booking.startDate}
                                setDate={(d) => {
                                  setBooking({ ...booking, startDate: d });
                                  dispatch(fetchEventSlots(branch._id, booking.room, { start: moment(d).format('YYYY-MM-DD') }, token));
                                }}
                              />
                            </div>
                          }

                          <div className="col-lg-10 my-2">
                            {slotLoading && <CircularProgress />}
                          </div>

                          {branch && booking.startDate && eventSlots &&
                            <div className="col-lg-10 my-2">
                              <p>Pick Slots</p>
                              <small className="text-info">Each slot has half hour duration</small>
                              <div className="form-check form-check-inline d-flex flex-wrap">
                                {eventSlots.length > 0 && eventSlots.map((slot, index) => (
                                  <button
                                    className={booking.slots.includes(slot) ? `btn btn-primary btn-sm m-2` : `btn btn-outline-primary btn-sm m-2`}
                                    key={index}
                                    onClick={() => {
                                      if (booking.slots.includes(slot)) {
                                        setBooking({ ...booking, slots: booking.slots.filter(x => x !== slot) });
                                      } else {
                                        setBooking({ ...booking, slots: [...booking.slots, slot] });
                                      }
                                    }}>
                                    {utils.slotHelper(slot)}
                                  </button>
                                ))}
                              </div>

                            </div>
                          }

                          {branch && booking.startDate && booking.slots.length > 0 && booking.room &&
                            <div className="col-lg-12 my-2">
                              <FormControlLabel
                                control={<Switch size="small" checked={booking.refreshments} onChange={(e) => setBooking({ ...booking, refreshments: e.target.checked })} />}
                                label="Refreshments"
                              />
                            </div>
                          }

                          {branch && booking.startDate && booking.slots.length > 0 && booking.room &&
                            <div className="col-lg-12 my-2">
                              <TextField
                                label="No. of People" variant="outlined"
                                value={booking.people}
                                type="number" min={30}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onChange={(e) => setBooking({ ...booking, people: e.target.value })}
                              />
                            </div>
                          }

                          {booking && booking.slots.length > 0 && booking.room && branch && user &&
                            <div className="col-lg-12 my-2">
                              <p>Total Amount is PKR {(getRate(booking.room, user.role) * booking.slots.length * 0.5).toFixed(0)}</p>
                            </div>
                          }

                          {booking && booking.slots.length > 0 && booking.room && branch &&
                            <div className="col-lg-12">
                              <div className="input-box mt-10">
                                <Button
                                  variant='contained'
                                  color='primary'
                                  disabled={bookingLoading}
                                  onClick={bookNow}
                                  startIcon={<CalendarTodayIcon />}
                                >Book Now
                              </Button>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </>
                  }
                </div>
              </div>
            </div>
            <QuickHelp />
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default BookEvent;
